module.exports = __webpack_public_path__ + "img/img-11.435fac08.png";